import { render, staticRenderFns } from "./RegionLimits.vue?vue&type=template&id=c15f03fa&"
import script from "./RegionLimits.vue?vue&type=script&lang=js&"
export * from "./RegionLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports